module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.6-95.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.1-rc.6.md
// module id = 512
// module chunks = 318